module.exports = __webpack_public_path__ + "img/FroSmokes@1x.cd3688c5.webp";